import _ from "lodash"
import { useMemo } from "react"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import {
  ProductCustomFieldsItemResponseDto,
  ProductStandardsItemResponseDto,
} from "~/gen/api"

export type StandardHeaders = {
  name: string
  certificates: LibraryResponses.StandardsCertificate[]
}

export const useCustomFieldsHeaders = (
  products: ProductCustomFieldsItemResponseDto[]
) => {
  const customHeaders = useMemo(() => {
    const customHeader: Record<string, string> = {}
    for (const p of products) {
      const newCustomHeader: Record<string, string> = Object.assign(
        {},
        ...Object.keys(p.flattenCustomFields).map((key) => ({ [key]: key }))
      )
      Object.assign(customHeader, newCustomHeader)
    }
    return customHeader
  }, [products])

  return customHeaders
}

export const useStandardsHeaders = (
  products: ProductStandardsItemResponseDto[],
  standardIdFilter?: number
) => {
  const standardHeaders = useMemo(() => {
    const flatStandards = products.flatMap((product) => product.standards ?? [])

    return _.uniqBy(flatStandards, "id").filter((standard) => {
      if (standardIdFilter) {
        return standard.id === standardIdFilter
      }
      return true
    })
  }, [products, standardIdFilter])

  return standardHeaders
}
